var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-nav-item-dropdown",
    { attrs: { right: "", "no-caret": "" } },
    [
      _c("template", { slot: "button-content" }, [
        _c("img", {
          staticClass: "img-avatar",
          attrs: {
            src: _vm.$auth.user()["info"]["avatar"],
            alt: _vm.$auth.user()["info"]["name"]
          }
        })
      ]),
      _vm._v(" "),
      _c("b-dropdown-header", [
        _vm._v(
          _vm._s(_vm.$t("hello")) +
            " " +
            _vm._s(_vm.$auth.user()["info"]["name"])
        )
      ]),
      _vm._v(" "),
      _c("b-dropdown-item", [
        _c("i", { staticClass: "fa fa-user" }),
        _vm._v(" " + _vm._s(_vm.$t("profile")))
      ]),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          on: {
            click: function($event) {
              _vm.logout()
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-lock" }),
          _vm._v(" " + _vm._s(_vm.$t("logout")))
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a8c5ef7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a8c5ef7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/HeaderDropdownAccnt.vue
// module id = 1120
// module chunks = 0